var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 617.861,
    height: 119.188,
    viewBox: "0 0 617.861 119.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(-471.349 -227.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M471.349,312.961V227.743h61.323v15.483H487.442v23.287h42.791v14.873H487.442v31.576Z",
    transform: "translate(0 0)",
    fill: "#2b3285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M506.2,239.9v60.347h14.875V239.9Z",
    transform: "translate(36.472 12.719)",
    fill: "#2b3285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M564.458,300.616V269.163c0-9.144-5-16.093-14.506-16.093-9.144,0-15.362,7.681-15.362,16.823v30.722H519.837V240.391h13.289l.976,8.168c6.095-5.974,12.192-9.022,19.75-9.022,14.142,0,25.481,10.606,25.481,29.5v31.576Z",
    transform: "translate(50.749 12.345)",
    fill: "#2b3285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M555.162,325.919V240.7h13.9l.976,8.291c4.631-6.7,12.679-9.632,19.506-9.632,18.53,0,30.845,13.776,30.845,31.453,0,17.556-11.095,31.455-30.358,31.455-6.339,0-15.727-1.95-19.994-8.534v32.187Zm50.349-55.108c0-9.386-6.338-17.067-17.067-17.067s-17.069,7.681-17.069,17.067a17.068,17.068,0,1,0,34.136,0Z",
    transform: "translate(87.722 12.158)",
    fill: "#2b3285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M641.744,240.763h14.265v60.1H641.988l-.731-8.776c-3.414,7.069-12.8,10.483-19.506,10.606-17.8.123-30.968-10.849-30.968-31.942,0-20.726,13.778-31.576,31.334-31.455,8.045,0,15.726,3.78,19.14,9.754Zm-36.086,29.991c0,11.459,7.922,18.287,17.8,18.287,23.407,0,23.407-36.453,0-36.453C613.58,252.588,605.658,259.3,605.658,270.754Z",
    transform: "translate(125.004 12.094)",
    fill: "#2b3285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M642.564,240.824l1.1,6.95c4.632-7.437,10.849-8.534,16.944-8.534,6.218,0,12.192,2.438,15.485,5.729l-6.707,12.925a14.857,14.857,0,0,0-10.728-3.9c-7.8,0-14.994,4.144-14.994,15.239v31.7H628.788v-60.1Z",
    transform: "translate(164.781 12.033)",
    fill: "#2b3285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M680.073,231.734V248.8h16.58v12.8h-16.7v25.97c0,5.729,3.168,8.532,7.8,8.532a17,17,0,0,0,7.194-1.828l4.144,12.679a33.248,33.248,0,0,1-12.312,2.56c-13.045.487-21.58-6.948-21.58-21.944V261.6H653.985V248.8H665.2V233.32Z",
    transform: "translate(191.154 4.177)",
    fill: "#2b3285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M724.7,300.616V269.163c0-9.144-5-16.093-14.509-16.093-9.142,0-15.36,7.681-15.36,16.823v30.722H680.075V240.391h13.289l.974,8.168c6.1-5.974,12.192-9.022,19.752-9.022,14.14,0,25.478,10.606,25.478,29.5v31.576Z",
    transform: "translate(218.46 12.345)",
    fill: "#2b3285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M729.449,276.3c.976,7.437,7.438,12.8,17.922,12.8,5.485,0,12.679-2.073,16.093-5.61l9.509,9.388c-6.338,6.584-16.7,9.754-25.845,9.754-20.726,0-33.039-12.8-33.039-32.065,0-18.287,12.435-31.453,31.94-31.453,20.117,0,32.675,12.435,30.358,37.183Zm32.672-12.313c-.974-7.8-7.069-11.7-15.6-11.7-8.047,0-14.629,3.9-16.825,11.7Z",
    transform: "translate(254.06 11.909)",
    fill: "#2b3285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M763.9,240.824l1.1,6.95c4.631-7.437,10.849-8.534,16.944-8.534,6.22,0,12.192,2.438,15.485,5.729l-6.707,12.925a14.857,14.857,0,0,0-10.729-3.9c-7.8,0-14.994,4.144-14.994,15.239v31.7H750.127v-60.1Z",
    transform: "translate(291.779 12.033)",
    fill: "#2b3285"
  }), /*#__PURE__*/React.createElement("text", {
    id: "YOUR_BUSINESS_PARTNER",
    "data-name": "YOUR BUSINESS PARTNER",
    transform: "translate(760.544 341.931)",
    fill: "#fff",
    fontSize: 21,
    fontFamily: "Helvetica",
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "YOUR BUSINESS PARTNER")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 15.115,
    height: 15.115,
    transform: "translate(542.766 227.803)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBig);
export default __webpack_public_path__ + "static/media/logo_big.50b2b23e3c10e32f6a3eef0488138adf.svg";
export { ForwardRef as ReactComponent };